import apis from "../../config/apis.json";
import { getAccessToken } from "../msal";
import { IPublicClientApplication } from "@azure/msal-browser";
import axios from "axios";
import { IGetRoleCollectionRequest, IRoleCollection } from "./interfaces";
import { QueryString } from "lib/common/query-string";

/**
 * Retrieves the role collection.
 *
 * @param instance The msal instance.
 * @returns The retrieved users.
 */
export async function getRoleCollection(instance: IPublicClientApplication, request: IGetRoleCollectionRequest): Promise<IRoleCollection[]> {
  const { scope, baseUrl } = apis.security;

  const queryString = QueryString.from(request.queryParams);
  const requestUrl = `${baseUrl}/apps/${request.appId}/role_collections${queryString}`;
  const accessToken = await getAccessToken(instance, scope);

  const result = await axios.get(
    requestUrl, {
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      }
    });

  return result.data;
}
